import * as React from 'react';
const NoDetailSvg = () => (
	<svg width={25} height={24} viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M3.5 13.125C3.5 12.5037 4.00368 12 4.625 12H6.875C7.49632 12 8 12.5037 8 13.125V19.875C8 20.4963 7.49632 21 6.875 21H4.625C4.00368 21 3.5 20.4963 3.5 19.875V13.125Z"
			stroke="#A63494"
			strokeWidth={1.5}
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M10.25 8.625C10.25 8.00368 10.7537 7.5 11.375 7.5H13.625C14.2463 7.5 14.75 8.00368 14.75 8.625V19.875C14.75 20.4963 14.2463 21 13.625 21H11.375C10.7537 21 10.25 20.4963 10.25 19.875V8.625Z"
			stroke="#A63494"
			strokeWidth={1.5}
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M17 4.125C17 3.50368 17.5037 3 18.125 3H20.375C20.9963 3 21.5 3.50368 21.5 4.125V19.875C21.5 20.4963 20.9963 21 20.375 21H18.125C17.5037 21 17 20.4963 17 19.875V4.125Z"
			stroke="#A63494"
			strokeWidth={1.5}
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);
export default NoDetailSvg;
